// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description[data-v-82cc3526] {\n  text-align: left;\n  box-shadow: -1px 1px 3px 3px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 20px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
